var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconClear = function SvgIconClear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12 22C6.578 22 2 17.522 2 12S6.578 2 12 2c5.542 0 10 4.477 10 10s-4.458 10-10 10m3.735-13.708c.361.39.361 1.024 0 1.415l-2.29 2.292 2.29 2.293a1.06 1.06 0 0 1 0 1.414c-.361.39-.964.39-1.446 0L12 13.414l-2.29 2.292a.896.896 0 0 1-1.324 0c-.482-.39-.482-1.022 0-1.414l2.289-2.293-2.29-2.292c-.481-.39-.481-1.024 0-1.415a.896.896 0 0 1 1.326 0L12 10.585l2.29-2.293c.481-.39 1.084-.39 1.445 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconClear;